import React from "react";
import error from "../assets/error.png"; // Adjust path as needed

const ErrorImage = ({ width = "30rem", height = "30rem" }) => {
  return (
    <div className="flex justify-center items-center py-6">
      <img
        src={error}
        alt="error..."
        className={`object-contain mt-0`}
        style={{ width, height }}
      />
    </div>
  );
};

export default ErrorImage;
